export default class CutTextDirective {
    constructor() {
        this.restrict = 'A';
        this.scope = { fontSize: '@', maxRows: '@', value: '<dbmDynamicText' };
        this.link = this.link.bind(this);
    }

    link(scope, element, attrs) {
        element.css('display', 'inline-block');
        element.css('height', 'auto');
        const parent = element.parent();
        const { fontSize, maxRows } = scope;
        this.adjust(element, parent, fontSize, maxRows, scope.value);
        const cancelWatch = scope.$watch('value', (newValue, oldValue) => {
            if (newValue !== undefined && newValue !== oldValue) {
                this.adjust(element, parent, fontSize, maxRows, newValue);
            }
        });
        scope.$on('$destroy', cancelWatch);
    }

    adjust(element, parent, fontSize = 32, maxRows = Infinity, value) {
        let divider, newFontSize;
        let iterator = 0;
        const minFontSize = fontSize / maxRows;
        newFontSize = fontSize;
        divider = 1;
        value = Math.round(value * 100) / 100;
        if (value >= 100) {
            value = Math.round(value);
        }
        element.html(value);
        parent.css('word-wrap', 'normal');
        parent.css('word-break', 'normal');
        parent.css('overflow', 'visible');
        element.css('max-width', '');
        const parentWidth = parent[0].clientWidth;
        const parentHeight = parent[0].clientHeight;
        const elementWidth = element[0].scrollWidth;
        if (elementWidth > parentWidth) {
            element.css('max-width', '100%');
            parent.css('word-wrap', 'break-word');
            parent.css('word-break', 'break-all');
            parent.css('overflow', 'hidden');
            do {
                iterator++;
                divider = elementWidth / parentWidth;
                newFontSize = newFontSize / (divider > maxRows ? maxRows : divider);
                newFontSize = newFontSize < minFontSize ? minFontSize : newFontSize;
                element.css('font-size', `${newFontSize}px`);
            } while ((element[0].scrollWidth > parentWidth || element[0].scrollHeight > parentHeight) && newFontSize > minFontSize && iterator < 100);
            if (divider > maxRows) {
                const asString = value.toString();
                const itemsPerRow = Math.floor((parentWidth / newFontSize) * 1.8);
                const visibleText = asString.slice(0, itemsPerRow * maxRows - 3);
                element.html(`${visibleText}...`);
                element.attr('title', value);
            }
        } else {
            element.css('font-size', `inherit`);
            element.removeAttr('title');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/shared/dynamic-text/dynamic-text.directive.js